import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { removeSiteError } from 'containers/App/actions';
import SiteError from './SiteError';

const SiteErrorContainer = () => {

  const errors = useSelector((state) => state.global.siteErrors);
  const dispatch = useDispatch();

  return (
    <div>
      {errors.map(error => {
        return (
          <SiteError
            key={error.uuid}
            removeSiteError={() => dispatch(removeSiteError(error.uuid))}
            {...error}
          />
        );
      })}
    </div>
  );
};

export default SiteErrorContainer;
